module.exports = {
  InteractivePlugin: {
    PluginName: "Plugin Interactivo",
    display_name: "Interactivo",
    flow_items: "Elementos de Flujo",
  },
};
